export class OrderLineCreateRequest {
  constructor(
    public itemId: number,
    public quantity: number) { }
}

export class DraftOrderLineFields {
  constructor(
    public itemId: number,
    public quantity: number,
    public unitCode: string,
    public managedFloor: number | null = null) { }
}

export default class OrderCreateRequest {
  constructor(
    public siteId: number,
    public deliveryDate: Date | undefined,
    public lines: OrderLineCreateRequest[]) { }
}
